module.exports = __webpack_public_path__ + "img/img.ca8dd9f3.png";